<template>
  <div class="user-info">
    <div class="user-info-wrap">
      <div class="user-info-icon">
        <img src="../../../assets/img/new_robot_icon.png" alt="" class="user-info-icon-img"/>
      </div>
      <p class="user-info-name">Hi，{{ this.userName }}</p>
      <p class="user-info-sub">我是您的客服转小多</p>
    </div>
  </div>
</template>

<script>
import { SentryCapture } from '@zz-common/sentry'
import { getUserInfo } from '../../../api/resourceApi'

export default {
  name: 'UserSection',
  data() {
    return {
      userName: ''
    }
  },
  methods: {
    getUserNickName() {
      getUserInfo()
        .then((resp) => {
          const { nickName = '' } = resp
          this.userName = nickName === '' ? '转转用户' : nickName
        })
        .catch((err) => {
          SentryCapture('获取昵称失败', 3, {
            extra: {
              errInfo: err
            }
          })
          this.userName = '转转用户'
        })
    }
  },
  mounted() {
    this.getUserNickName()
  }
}
</script>

<style lang="less" scoped>
  @import './UserSection.less';
</style>
